<header></header>
<div class="post-login-1">
    <div class="post-login-1-col-1 h-100">
        <!-- <app-left-panel-prelogin activeTab="4"></app-left-panel-prelogin> -->
        <left-panel activeTab="4" *ngIf="this.auth?.detailuser != undefined"></left-panel>
        <app-left-panel-prelogin activeTab="4" *ngIf="this.auth?.detailuser == undefined"></app-left-panel-prelogin>
    </div>
    <div class="post-login-1-col-2">
        <div class="discover-box bg-8f8">
            <grid-row class="mt-20 justify-content-between align-item-center">
                <grid-col col="4">
                    <div class="font-600 font-size-32px line-h-40 letter-spacing-03">
                        {{"MYFAVOffers" | translate }}
                    </div>
                </grid-col>
                <!-- <grid-col col="auto">
                    <ng-icon iconClass="icon-like-32px" width="32" height="32"></ng-icon>
                    <ng-icon iconClass="icon-filter-big ml-20" width="32" height="32"></ng-icon>
                </grid-col> -->
            </grid-row>
            <!-- <div class="img-box mt-30">
                <img src="../../assets/images/offer-banner-img.jpg" alt="">
                <div class="text-box">
                    <div class="font-600 font-size-20px line-h-32 color-base-100">
                        {{"BannerText" | translate }}
                    </div>
                    <grid-row class="mt-25">
                        <grid-col col="auto">
                            <ng-icon iconClass="icon-heart-white" width="18" height="22"></ng-icon>
                            <ng-icon iconClass="icon-heart-active" width="18" height="25"></ng-icon>
                            <span class="font-500 font-size-12px line-h-18 color-base-100 ml-5">
                                2356
                            </span>
                        </grid-col>
                    </grid-row>
                </div>
            </div> -->
            <div class="mt-40">
                <grid-row class="col-space-min">
                    <grid-col col="12">
                        <!-- <grid-row class="justify-content-between align-item-center mb-20">
                            <grid-col col="auto">
                                <div class="font-600 font-size-14px line-h-20 color-base-1200">
                                    {{ "DEALSAROUNDYOU" | translate }}
                                </div>
                            </grid-col>
                            <grid-col col="auto">
                                <div class="font-600 font-size-14px line-h-20 color-base-2200 link">
                                    {{ "ViewAll" | translate }}
                                </div>
                            </grid-col>
                        </grid-row> -->
                    </grid-col>
                    <grid-col col="4" class="mt-ipad-15" mobile="12" ipad="6" *ngFor="let item of this.FavouriteOffers; let i = index;">
                        <div class="deal-card" (click)="landingPageOfferDetails(item.id)" >
                            <div class="card-img"  >
                                <!-- <img src="~/../assets/images/deal-1-card-img.png" alt=""> -->
                                <img src="data:image/jpg;base64,{{item.thumbnailBase64}}"alt="">
                            </div>
                            <div class="content-box" >
                                <div
                                    class="font-600 font-size-10px color-base-800 line-h-12 letter-spacing-1 text-uppercase mt-14">
                                    {{item.title}}
                                </div>
                                <div class="font-400 font-size-14px color-base-2800 letter-spacing-2 line-h-20 mt-10">
                                    {{item.caption}}
                                </div>
                                <grid-row class="mt-30 align-item-center">
                                    <grid-col col="auto">
                                        <!-- <ng-icon  [itemStatus]="true" width="18" height="25"></ng-icon> -->
                                        <!-- <wishlist  [itemStatus]="true"></wishlist> -->
                                        <wishlist (returnClick)="heartIcon(item.id,i)" [itemStatus]="item.heart" *ngIf="this.auth?.detailuser"></wishlist>

                                        <!-- <ng-icon iconClass="icon-heart-active" width="18" height="25"></ng-icon> -->
                                    </grid-col>
                                    <!-- <grid-col col="auto">
                                        <span class="font-500 font-size-12px line-h-18 letter-spacing-1 ml-5">
                                            2356
                                        </span>
                                    </grid-col> -->
                                </grid-row>
                            </div>
                        </div>
                    </grid-col>
                    <!-- <grid-col col="4" class="mt-ipad-15" mobile="12" ipad="6">
                        <div class="deal-card">
                            <div class="card-img" (click)="landingPageOfferDetails()">
                                <img src="../../assets/images/airport-hotel-img.png" alt="">
                            </div>
                            <div class="content-box">
                                <div
                                    class="font-600 font-size-10px color-base-800 line-h-12 letter-spacing-1 text-uppercase mt-14">
                                    {{"bahrainAirportHotel" | translate }}
                                </div>
                                <div class="font-400 font-size-14px color-base-2800 letter-spacing-2 line-h-20 mt-10">
                                    {{"GetOffOnBill" | translate }}
                                </div>
                                <grid-row class="mt-50 align-item-center">
                                    <grid-col col="auto">
                                        <ng-icon iconClass="icon-heart-black" width="18" height="25"></ng-icon>
                                    </grid-col>
                                    <grid-col col="auto">
                                        <span class="font-500 font-size-12px line-h-18 letter-spacing-1 ml-5">
                                            2356
                                        </span>
                                    </grid-col>
                                </grid-row>
                            </div>
                        </div>
                    </grid-col> -->
                   
                </grid-row>
            </div>
        </div>
    </div>
    <!-- <div class="post-login-1-col-3">
        <div class="pl-20 pr-20">
            <div class="font-400 font-size-14px line-h-20 color-base-1500 mt-14 letter-spacing-1 mb-10">
                {{"Sponsored" | translate }}
            </div>
            <div class="deal-card pt-10 pb-10">
                <div class="card-img">
                    <img src="~/../assets/images/heath-coverage-img.jpg" alt="">
                </div>
                <div class="content-box bg-2900">
                    <div class="font-600 font-size-14px line-h-20 color-base-1500">
                        {{"NeedMedicalInsurance" | translate }}
                    </div>
                    <div class="font-400 font-size-14px line-h-20 color-base-600 mt-8">
                        {{"GetYourFamilyMedical" | translate }}
                    </div>
                </div>
            </div>
        </div>
    </div> -->
</div>